import React__default from 'react';
import Box from './Box.js';
import Icon from './Icon.js';
import IconButton from './IconButton.js';
import LinkButton from './LinkButton.js';
import Typography from './Typography.js';

const colors = {
  success: 'success',
  info: 'info',
  error: 'error'
};
const iconMap = {
  success: '24-checkmark-rounded',
  info: '24-info',
  error: '24-warning'
};

const InlineNotification = ({
  closeTestID,
  ctaHref,
  ctaOpenNewWindow,
  ctaTestID,
  ctaText,
  descriptionText,
  onCtaPress,
  onRequestToClose,
  paddingBottom = 'small',
  paddingHorizontal = 'small',
  paddingTop = 'small',
  testID,
  titleText,
  variant,
  customIcon,
  children
}) => {
  const variantColor = colors[variant];
  const variantIcon = iconMap[variant];
  return /*#__PURE__*/React__default.createElement(Box, {
    backgroundColor: "elevated",
    borderColor: "primary",
    borderRadius: "base",
    borderStyle: "solid",
    borderWidth: "base",
    boxShadow: "dark",
    flexDirection: "column",
    paddingBottom: paddingBottom,
    paddingHorizontal: paddingHorizontal,
    paddingTop: paddingTop,
    testID: testID
  }, /*#__PURE__*/React__default.createElement(Box, {
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "tiny",
    flex: 1,
    display: "flex"
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React__default.createElement(Box, {
    marginRight: "tiny",
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: customIcon !== null && customIcon !== void 0 ? customIcon : variantIcon,
    color: variantColor
  })), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "headline-3",
    color: variantColor
  }, titleText)), /*#__PURE__*/React__default.createElement(Box, null, onRequestToClose && /*#__PURE__*/React__default.createElement(IconButton, {
    name: "24-close-small",
    onPress: onRequestToClose,
    testID: closeTestID
  }))), children || /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body-1",
    color: "primary"
  }, descriptionText)), ctaText && (ctaHref || onCtaPress) && /*#__PURE__*/React__default.createElement(Box, {
    marginTop: "medium"
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    href: ctaHref,
    onPress: onCtaPress,
    openNewWindow: ctaOpenNewWindow,
    testID: ctaTestID
  }, ctaText))));
};

export { InlineNotification as I };
//# sourceMappingURL=notification-785219c0.js.map
